<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  background: #f0f2f5;
}
.page-card {
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}

/* ============ 移动端适配（<=768px） ============ */
@media (max-width: 768px) {
  /* 主区域留白收紧 */
  .el-main.main {
    padding: 10px;
  }
  .page-card {
    padding: 12px;
    border-radius: 4px;
  }
  .el-header.header {
    padding: 0 12px;
  }

  /* 栅格：默认一列；仪表盘统计卡保持两列 */
  [class*='el-col-'] {
    width: 100% !important;
    margin-left: 0 !important;
  }
  .stat-row [class*='el-col-'],
  .queue-row [class*='el-col-'] {
    width: 50% !important;
  }
  .el-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .el-col {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  /* 筛选栏：控件占满一行，按钮平分宽度 */
  .filter-bar,
  .search-bar {
    gap: 8px;
  }
  .filter-bar .el-input,
  .filter-bar .el-select,
  .filter-bar .el-date-editor,
  .search-bar .el-input,
  .search-bar .el-select,
  .search-bar .el-date-editor {
    width: 100% !important;
  }
  .filter-bar .el-button,
  .search-bar .el-button {
    flex: 1 1 40%;
    margin-left: 0 !important;
  }
  .filter-bar > div[style*='flex: 1'],
  .search-bar > div[style*='flex: 1'] {
    display: none;
  }

  /* 表格：字号缩小 + 可横向滚动 */
  .el-table {
    font-size: 12px;
  }
  .el-table th,
  .el-table td {
    padding: 6px 0;
  }
  .el-table .cell {
    padding-left: 6px;
    padding-right: 6px;
  }
  .el-table__fixed-right {
    box-shadow: none;
  }

  /* 分页：竖排，隐藏每页条数与跳页 */
  .pager-bar {
    margin-top: 12px;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .pager-bar .el-button {
    width: 100%;
  }
  .el-pagination {
    padding: 0;
    white-space: normal;
  }
  .el-pagination__sizes,
  .el-pagination__jump {
    display: none !important;
  }
  .el-pagination button,
  .el-pagination li {
    min-width: 26px;
  }

  /* 弹窗 / 提示框宽度自适应 */
  .el-dialog {
    width: 94% !important;
    margin-top: 6vh !important;
  }
  .el-message-box {
    width: 88% !important;
  }
  .el-message {
    min-width: 88%;
  }
  .el-drawer {
    max-width: 88%;
  }

  /* 表单：label 改为上下排布，避免 110px 标签挤压输入区 */
  .el-form-item__label {
    float: none;
    display: block;
    text-align: left;
    width: auto !important;
    line-height: 22px;
    padding: 0 0 4px;
  }
  .el-form-item__content {
    margin-left: 0 !important;
    line-height: 32px;
  }
  .el-form-item {
    margin-bottom: 14px;
  }
  .edit-header {
    flex-wrap: wrap;
    gap: 10px;
  }
  /* 容量卡头部、「新建 / 刷新」等行内操作换行显示 */
  .cap-head,
  .card-head,
  .section-head {
    flex-wrap: wrap;
    gap: 8px;
  }

  /* 移动端惯性滚动 */
  .el-main.main {
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
  }

  /* 标签页过多时可横向滚动 */
  .el-tabs__nav-wrap.is-scrollable {
    padding: 0 8px;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    display: block;
  }
}
</style>
